var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "navbar is-primary is-fixed-top has-shadow" },
    [
      _c(
        "div",
        { staticClass: "navbar-brand" },
        [
          _c(
            "RouterLink",
            { staticClass: "navbar-item", attrs: { to: { name: "Home" } } },
            [
              _vm.$store.getters["ui/authLogo"]
                ? _c("img", {
                    attrs: {
                      alt: "company logo",
                      src: _vm.$store.getters["ui/authLogo"]
                    }
                  })
                : _c("h4", { staticClass: "title is-4" }, [
                    _vm._v("\n        machete\n      ")
                  ])
            ]
          ),
          _c(
            "a",
            {
              staticClass: "navbar-burger burger",
              attrs: {
                role: "button",
                "aria-label": "menu",
                "aria-expanded": "false",
                "data-target": "navbar-menu"
              },
              on: { click: _vm.toggleNavbarMenu }
            },
            [
              _c("span", { attrs: { "aria-hidden": "true" } }),
              _c("span", { attrs: { "aria-hidden": "true" } }),
              _c("span", { attrs: { "aria-hidden": "true" } })
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "navbar-menu",
          class: _vm.navbarMenuIsActive,
          attrs: { id: "navbar-menu" }
        },
        [
          _c("AppMenu", { staticClass: "navbar-start" }),
          _c("div", { staticClass: "navbar-end" }, [
            _c(
              "span",
              { staticClass: "navbar-item is-flex is-centered" },
              [
                _c(
                  "RouterLink",
                  {
                    staticClass: "button is-danger is-outlined",
                    attrs: {
                      "active-class": "is-active",
                      to: { name: "SignOut" }
                    }
                  },
                  [_c("BIcon", { attrs: { icon: "exit-to-app" } })],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }